import { AddGlobalAddressWhitelistRequest } from './add.global.address.whitelist.request';

export class EditGlobalAddressWhitelistRequest extends AddGlobalAddressWhitelistRequest {
    GlobalAddressWhiteListID: number;
}
